import React from 'react';
import CurrencyIcon, { TetherIconColorOptions } from '../CurrencySymbolMask/CurrencyIcon';
import { formatCurrency } from '@/pages/table/utils/utils';
import TooltipWrapper, { TriggerType } from '../new-design/ToolTipWrapper';
import { IoIosInformationCircleOutline } from 'react-icons/io';

interface TableStakeInfoProps {
  smallBet?: number;
  bigBet?: number;
  ante?: number;
  smallBlind?: number;
  bigBlind?: number;
  isHighStakes?: boolean;
  fontSize?: string;
  color?: string;
}

const TableStakeInfo: React.FC<TableStakeInfoProps> = ({
  smallBet,
  bigBet,
  ante,
  smallBlind,
  bigBlind,
  isHighStakes,
  fontSize = '',
  color = TetherIconColorOptions.green,
}) => {
  const formattedSmallBet = formatCurrency(smallBet, { shortFormat: true });
  const formattedBigBet = formatCurrency(bigBet, { shortFormat: true });
  const formattedAnte = formatCurrency(ante, { shortFormat: true });
  const formattedSmallBlind = formatCurrency(smallBlind, { shortFormat: true });
  const formattedBigBlind = formatCurrency(bigBlind, { shortFormat: true });

  const blind = () => {
    const isSmallBet = smallBet && smallBet > 0;

    return (
      <>
        <span className="flex flex-row items-center">
          <span className="flex flex-row items-center gap-0.5">
            {isHighStakes && (
              <TooltipWrapper
                content={
                  <span className="text-sm font-semibold text-white">
                    Your full name will always be displayed on this table.
                  </span>
                }
                fullDimensions={false}
                triggerType={TriggerType.HOVER}
              >
                <IoIosInformationCircleOutline className="h-6 w-6 cursor-pointer pr-1 text-ph-white-30" />
              </TooltipWrapper>
            )}
            {isSmallBet ? formattedSmallBet : formattedSmallBlind}
          </span>
          <span className="mx-2 font-bold">/</span>
          <span className="flex flex-row items-center gap-0.5">
            {isSmallBet ? formattedBigBet : formattedBigBlind}&nbsp;
          </span>
          <CurrencyIcon fill={color} />
        </span>
      </>
    );
  };

  return (
    <span className={`mx-1 flex flex-col items-center ${fontSize ? fontSize : 'text-xs xl:text-sm'}`}>
      <div className="flex">{blind()}</div>
      {ante && ante > 0 && (
        <div className="ml-4 mt-1 flex items-center gap-0.5">
          <p className="text-s block truncate whitespace-nowrap text-sm font-bold">
            <span className="text-ph-white-50">Ante</span> <span className="text-white">{formattedAnte}</span>
          </p>
        </div>
      )}
    </span>
  );
};

export default TableStakeInfo;
